import { useEffect, useState } from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { ScrollableDialogProps } from "../Dialogs";
import { useUiStore } from "@/store/ui";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { postCorreoExcedente } from "@/shared/actions/erp"; // ajusta si lo exportaste en otro lado

interface DatosExcedente {
  codigo?: string; descripcion?: string; tipo?: string;
  solicitado?: number; enviado?: number; diferencia?: number;
}
interface Props {
  open: boolean;
  onClose: () => void;
  codigoSolicitud?: string;
  diffs: DatosExcedente[];
  onEnviado: (correo: { email: string; asunto: string; mensaje: string }) => void;// se llama al enviar con éxito (para guardar el producto)
}

export default function ModalCorreoExcedente({ open, onClose, codigoSolicitud, diffs, onEnviado }: Props) {
  const setAlert = useUiStore((s) => s.setAlert);
  const [email, setEmail] = useState("");
  const [asunto, setAsunto] = useState("");
  const [mensajeAdicional, setMensajeAdicional] = useState("");
  const [enviando, setEnviando] = useState(false);

  const bloqueFijo =
      `Diferencias en transferencia de pedido ${codigoSolicitud ?? ''}:\n\n` +
      (diffs ?? []).map(d =>
        `• ${d.codigo}${d.descripcion ? ' (' + d.descripcion + ')' : ''} — ${d.tipo}: ` +
        `solicitado ${d.solicitado}, enviado ${d.enviado}, diferencia ${d.diferencia}`
      ).join('\n');
  
  
      
  useEffect(() => {
  if (open) {
    setAsunto(`Diferencias en transferencia de pedido ${codigoSolicitud ?? ''}`);
    setEmail("");
    setMensajeAdicional("");
  }
  }, [open, codigoSolicitud]);
  const tipo = diffs[0]?.tipo ?? "DIFERENCIA";
  const handleEnviar = async () => {
    if (!email.trim()) return setAlert(true, "Debe indicar el correo destinatario.", AlertSeverityEnum.error);
    if (!asunto.trim()) return setAlert(true, "El asunto es obligatorio.", AlertSeverityEnum.error);
    const mensaje = bloqueFijo + (mensajeAdicional.trim() ? `\n\n${mensajeAdicional.trim()}` : "");
    try {
      setEnviando(true);
      const resp = await postCorreoExcedente({ email: email.trim(), asunto: asunto.trim(), mensaje });
      if (resp?.code && resp.code !== 200) {
        return setAlert(true, resp.message || "No se pudo enviar el correo.", AlertSeverityEnum.error);
      }
      setAlert(true, "Correo enviado correctamente.", AlertSeverityEnum.success);
      onEnviado({ email: email.trim(), asunto: asunto.trim(), mensaje });
      onClose();
    } catch {
      setAlert(true, "Error al enviar el correo.", AlertSeverityEnum.error);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <ScrollableDialogProps
      open={open}
      title={`Registrar ${tipo} por correo`}
      minWidth="50%"
      onCloseIcon={onClose}
      onClose={onClose}
      showConfirmBtn
      confirmTextBtn={enviando ? "Enviando..." : "Enviar correo"}
      confirmBtnColor="success"
      confirmVariantBtn="contained"
      confirmDisabled={enviando}
      onConfirm={handleEnviar}
      contentNode={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              Se detectó un excedente sobre lo solicitado. Registra el envío por correo para continuar.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField label="Correo destinatario" fullWidth required value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="correo@dominio.com (varios separados por coma)" />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Asunto" fullWidth value={asunto}
              onChange={(e) => setAsunto(e.target.value)} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline">Detalle (no editable)</Typography>
            <Box sx={{ p: 1.5, borderRadius: 1, bgcolor: "action.hover",
              whiteSpace: "pre-wrap", fontFamily: "monospace", fontSize: "0.85rem" }}>
              {bloqueFijo}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <TextField label="Mensaje adicional (opcional)" fullWidth multiline minRows={3}
              value={mensajeAdicional} onChange={(e) => setMensajeAdicional(e.target.value)} />
          </Grid>
        </Grid>
      }
    />
  );
}